// import { ArrayType } from '@angular/compiler';
import { Component , Renderer2} from '@angular/core';
import { FormGroup, FormControl, Validators , FormBuilder, FormsModule, ReactiveFormsModule} from '@angular/forms';
import $ from 'jquery';
import { CommonEventService } from '../services/common-event.service';
import { ApiService } from '../services/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LocationStrategy } from '@angular/common';
import { HostListener } from '@angular/core';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
@Component({
    selector: 'app-additional-component-details',
    templateUrl: './additional-component-details.component.html',
    styleUrls: ['./additional-component-details.component.css'],
    imports: [ ReactiveFormsModule,FormsModule,CommonModule ],
    standalone: true
})
export class AdditionalComponentDetailsComponent {
  public components :any = {};
  public selectedOptions: string[] = [];
  public dropdownOpen = false;
  public dropDownOptionsClick: boolean = false;
  public option:any = {};
  public accepted : boolean = true;
  flowActivityId:any='';
  additionalPageEventObj:any={};
  navigateToSignInPage: boolean = false;
  headerCheck = false;

  constructor(public apiService : ApiService,
    public commonService : CommonEventService,
    private router: Router,
    public formBuilder : FormBuilder,
    private renderer: Renderer2,
    private location: LocationStrategy){
      // if(localStorage.getItem('apDtId')){
      //   var apiObj:any = localStorage.getItem('apiSerDataObj')
      //   var commonObj:any = localStorage.getItem('commonDataObj')
      //   this.apiService.apiMainObj = JSON.parse(apiObj) 
      //   this.commonService.commonMainObj = JSON.parse(commonObj)
      //   this.commonService.commonMainObj.isGuestUser = false;
      // }

      this.renderer.listen('window', 'click', (e: Event) => {
        if (!this.dropDownOptionsClick) {
          this.dropdownOpen = false;
        }
        this.dropDownOptionsClick = false;
      });
  }
  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }
  preventCloseOnClick() {
    this.dropDownOptionsClick = true;
  }

  ngOnInit(): void {
    this.commonService.formattingCurrentDateTime();
    this.commonService.restrictBrowserButtons();
    if(localStorage.getItem('apDtId')){
      this.apiService.getAppStoreData(localStorage.getItem('apDtId')).subscribe((storeAppDataObj) =>{
        let strAppDt = JSON.parse(storeAppDataObj.fileData)
        this.apiService.apiMainObj = JSON.parse(strAppDt.data['apiSerDataObj'])
        this.commonService.commonMainObj = JSON.parse(strAppDt.data['commonDataObj'])
        if(this.commonService.commonMainObj.savedBomFileName){
          this.apiService.getSavedBomFIleData(this.commonService.commonMainObj.savedBomFileName).subscribe((data) =>{
            this.commonService.commonMainObj.retrivedBomFileDta =data.body;
          }, error =>{
            console.log('Bom file saving Error1', error);
          });
        }
        this.guestUserStoreDataGet();
      })
    }else{
      this.guestUserStoreDataGet()
    }
  }
  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent) {
    const perfEntries :any = performance.getEntriesByType("navigation");
    this.commonService.formattingCurrentDateTime();
    if (perfEntries.length > 0 && perfEntries[0].type === "reload") {
      console.log("Page was refreshed");
    }else{
      console.log("Likely tab close");
      if(this.commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'){
        const customIssuesArray = Object.entries(this.commonService.commonMainObj.customQuoteParam).map(([key, value]) => ({[key]: value}));
        this.additionalPageEventObj ={
          sourceApp: 'oneflow',
          eventType: this.commonService.commonMainObj.pcbType == 'Custom/Advanced PCB' ? 'CustomFlow' : 'FinalQuote',
          emailAddress: this.commonService.commonMainObj.boardDetailsDataObj.email ? this.commonService.commonMainObj.boardDetailsDataObj.email:'',
          triggerDate:this.commonService.commonMainObj.formattedDate +'-'+this.commonService.commonMainObj.capturedEventTime,
          createdAt:this.commonService.commonMainObj.capturedEventCreatedAt,
          customReasons:  customIssuesArray
        }
      }else{
        this.additionalPageEventObj ={
          sourceApp: 'oneflow',
          eventType: this.commonService.commonMainObj.pcbType == 'Custom/Advanced PCB' ? 'CustomFlow' : 'FinalQuote',
          emailAddress: this.commonService.commonMainObj.boardDetailsDataObj.email ? this.commonService.commonMainObj.boardDetailsDataObj.email:'',
          triggerDate:this.commonService.commonMainObj.formattedDate +'-'+this.commonService.commonMainObj.capturedEventTime,
          createdAt:this.commonService.commonMainObj.capturedEventCreatedAt
        }
      }
      
      const blob = new Blob([JSON.stringify(this.additionalPageEventObj)], {
        type: 'application/json'
      });
      if(!this.commonService.commonMainObj.logoClicked && this.navigateToSignInPage == false){
        this.apiService.callAPIToSendCapturedEvent(blob);
      }
    }
    // // OFP-2560 dashboard
    if(this.navigateToSignInPage == false){
      this.apiService.updateSessionTimeSpent(this.flowActivityId,'AdditionalComponentDetailsPage');
      console.log("checkk");
    }
    //  event.preventDefault();
    //  event.returnValue = false;
  }
  
  guestUserStoreDataGet(){
    if(this.commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'){
      if(localStorage.getItem('apDtId')){
        this.commonService.commonMainObj.isGuestUser = false;
        setTimeout(()=>{
          this.apiService.apiMainObj.encUrlData = localStorage.getItem('encData')
          this.userSessionCheck();
        },700);
      }else{
        this.commonService.loadingShow();
        setTimeout(() => {
          this.commonService.loadingHide();
        }, 500);
      }
    }
    this.components.selectedComponent = '';
    // console.log("components", this.commonService.commonMainObj.allAvailableComponets);
    // this.option = this.commonService.commonMainObj.allAvailableComponets.map((item:any) =>{
    //   return { component: item, selected: false };
    // })
    // console.log("option", this.option);
    for(var idx in this.commonService.commonMainObj.allAvailableComponets){
      for(var jdx in this.commonService.commonMainObj.uploadedBomDataItems){
        if(this.commonService.commonMainObj.uploadedBomDataItems[jdx]['imported']){
          if(this.commonService.commonMainObj.allAvailableComponets[idx].mpn == this.commonService.commonMainObj.uploadedBomDataItems[jdx]['imported'].mpn){
            this.commonService.commonMainObj.allAvailableComponets[idx].description = this.commonService.commonMainObj.uploadedBomDataItems[jdx]['imported'].description
          }
        }
      }
    }

    setTimeout(() => {
      if(!this.commonService.commonMainObj.invalidUser){
        let additionalData={
          "pageVisited":"Date:  "+this.commonService.commonMainObj.formattedDate+" " +"Time:"+this.commonService.commonMainObj.formattedTime
        }
         this.flowActivityId = this.commonService.commonMainObj.backToPrevPageActivityId != '' ? this.commonService.commonMainObj.backToPrevPageActivityId:this.commonService.commonMainObj.fileId;
        this.apiService.updateDetailsToDashboard(this.flowActivityId,additionalData,'AdditionalComponentDetailsPage').subscribe((resDatas)=>{
        },err=>{
          console.log(err)
        });
      }
    }, 1000);
  }

  userSessionCheck(){
    this.commonService.loadingShow();
    let sessionData = localStorage.getItem('encData')
    this.apiService.getUserDataSession(sessionData).subscribe((resData: any)=>{
      this.commonService.loadingHide();
      this.commonService.commonMainObj.userSessionMemberId = resData.memberId;
      if(localStorage.getItem('apDtId') && localStorage.getItem('apDtId') != ''){
        if(resData && resData.status == "NO_SESSION"){
          this.commonService.commonMainObj.userData = {};
          this.commonService.commonMainObj.sessionCheck = false;
          this.commonService.commonMainObj.isGuestUser = true;
        }else if(resData && resData.status == 'SESSION_FOUND'){
            this.commonService.commonMainObj.loginEmail = resData.registrationEmail
          if(this.commonService.commonMainObj.email && resData.registrationEmail != this.commonService.commonMainObj.email){
            this.commonService.commonMainObj.invalidUser = true;
            this.commonService.commonMainObj.boardDetailsDataObj.email = resData.registrationEmail;
          }
          this.commonService.commonMainObj.userId = resData.userId
          this.commonService.commonMainObj.userData = resData;
          this.commonService.commonMainObj.sessionCheck  = true;
          this.commonService.commonMainObj.isGuestUser = false;
        }
      }
      //this.initFn();
      if(this.commonService.commonMainObj.tryToSigninOrRegister){
        setTimeout(() => {
          let signInMsgObj={
            "navigatedTo":this.commonService.commonMainObj.newUser? 'Registration Page':'Sign-in Page',
            "signIn": this.commonService.commonMainObj.invalidUser ? "Sign In failed, different email used. Email: " + this.commonService.commonMainObj.loginEmail: this.commonService.commonMainObj.newUser? 'Registration successful. Email:' + this.commonService.commonMainObj.loginEmail:'Sign-in successful. Email:'+this.commonService.commonMainObj.loginEmail
          };
      
          this.apiService.updateDetailsToDashboard(this.flowActivityId,signInMsgObj,'SignInRegistrationPage').subscribe((resDatas)=>{
          },err=>{
            console.log(err)
          });  
        }, 1500);
      }
    },err=>{
      if(err.status == 200){
        if(err.error.text == "NO_SESSION"){
          this.commonService.commonMainObj.sessionCheck = false;
        }else{
          this.commonService.commonMainObj.userData = {};
        }
      }else{
        
      }
      console.log(err)
    });
  }
  changeOption(event:any){
    this.components.selectedComponent = '';
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if(value == 'No' || value == ''){
      this.commonService.commonMainObj.listOfMpnsSelected = [];
      for(var i in this.commonService.commonMainObj.allAvailableComponets){
        this.commonService.commonMainObj.allAvailableComponets[i].checkedModel = false;
      }
      // this.selectedOptions = [];
      // this.commonService.commonMainObj.listOfMpnsSelected = this.selectedOptions; 
      // for(let item in this.option ){
      //   this.option[item].selected = false;
      // }
    }
  }
  updateSelectedOptions() {
    this.selectedOptions = this.option
      .filter((option: any) =>option.selected)
      .map((option:any) =>option.component);
    this.commonService.commonMainObj.listOfMpnsSelected = this.selectedOptions;
  }

  selectComponentsChange(event:any){
    this.components.selectedComponent = '';
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if(value != ''){
      this.commonService.commonMainObj.listOfMpnsSelected.push(value);
    }
    this.commonService.commonMainObj.allAvailableComponets = this.commonService.commonMainObj.allAvailableComponets.filter((item:any) => item !== value);
  }

  removeSelectedComponent(selectedCompToRemove:any){
    // this.commonService.commonMainObj.listOfMpnsSelected = this.commonService.commonMainObj.listOfMpnsSelected.filter((item: any) => item !== selectedCompToRemove);
    // this.commonService.commonMainObj.allAvailableComponets.unshift(selectedCompToRemove);
    // setTimeout(() => {
    //   this.components.selectedComponent = '';
    // }, 200);
    
    this.selectedOptions = this.selectedOptions.filter(item => item !== selectedCompToRemove);
    this.commonService.commonMainObj.listOfMpnsSelected = this.selectedOptions; 
    for(let item in this.option ){
      if(this.option[item].component == selectedCompToRemove){
        this.option[item].selected = false;
      }
    }
    console.log("this.commonService.commonMainObj.listOfMpnsSelected", this.commonService.commonMainObj.listOfMpnsSelected);
  }

  continueFromAdditional(){
    this.commonService.sessionPortalLoad();
    let allSelectedComponents = JSON.stringify(this.commonService.commonMainObj.listOfMpnsSelected);
    this.commonService.commonMainObj.finalSelectedComponetesSet = allSelectedComponents.toString();

    if(this.commonService.commonMainObj.aqueousSelectOption == ''){
      this.commonService.alertCall("Alert!", 'Please specify if components can be washed or not');
    }else if(this.commonService.commonMainObj.aqueousSelectOption == 'Yes' && this.commonService.commonMainObj.listOfMpnsSelected == ''){
      this.commonService.alertCall("Alert!", 'Please specify Which components cannot be washed');
    }else{
      if(this.commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'){
        localStorage.setItem('apDtId','')
        this.router.navigateByUrl('/orderDetails');
      }else{
         let customQuoteObj={
          "quoteRequestPlaced":'Yes',
        }
        this.apiService.updateDetailsToDashboard(this.flowActivityId,customQuoteObj,'ConfirmQuoteQuoteDetailsPage').subscribe((resDatas)=>{
        });
        if(this.commonService.commonMainObj.aqueousSelectOption == 'Yes' && this.commonService.commonMainObj.listOfMpnsSelected != ''){
          let refDesigList:any = [];
          this.commonService.commonMainObj.qtyOfComponentsCannotbeWashed = this.commonService.commonMainObj.listOfMpnsSelected.length;
          for(var i in this.commonService.commonMainObj.finalLineItemsInCustomCPP){
            for(var j in this.commonService.commonMainObj.listOfMpnsSelected){
              if(this.commonService.commonMainObj.finalLineItemsInCustomCPP[i].mpn == this.commonService.commonMainObj.listOfMpnsSelected[j]){
                refDesigList.push(this.commonService.commonMainObj.finalLineItemsInCustomCPP[i].refDes);
              }
            }
            this.commonService.commonMainObj.refDesignatorCannotBewashed=refDesigList.join(",");
          }
        }
     
        if(this.commonService.commonMainObj.isGuestUser == true){
          let formToSaveBomData = new FormData();
          if(this.commonService.commonMainObj.bomFileData.body){
            this.commonService.commonMainObj.uploadedFile = this.commonService.commonMainObj.uploadedFile.body
            this.commonService.commonMainObj.bomFileData = this.commonService.commonMainObj.bomFileData.body
          }
          formToSaveBomData.append('file', this.commonService.commonMainObj.bomFileData);
          formToSaveBomData.append('emailId', this.commonService.commonMainObj.email);
          // console.log("this.commonService.commonMainObj.bomFileData",this.commonService.commonMainObj.bomFileData);
          this.commonService.commonMainObj.tryToSigninOrRegister = true;
          this.apiService.saveTheBomFile(formToSaveBomData).subscribe((data) =>{
            if (data) {
              this.commonService.commonMainObj.savedBomFileName = data.filename; 
              // console.log(" this.commonService.commonMainObj.savedBomFileName1", this.commonService.commonMainObj.savedBomFileName);
              // localStorage.setItem('commonDataObj','')
              // localStorage.setItem('commonDataObj',JSON.stringify(this.commonService.commonMainObj));
              // localStorage.setItem('apiSerDataObj','')
              // localStorage.setItem('apiSerDataObj',JSON.stringify(this.apiService.apiMainObj));
              this.apiService.saveAppData().subscribe((appDataObj) =>{
                localStorage.setItem('apDtId','')
                localStorage.setItem('apDtId',appDataObj.id);
                this.navigateToSignInPage = true;
                if( this.commonService.commonMainObj.newUser == false){
                  var redirectUrl = this.apiService.portalUrl + 'customer-portal/login/?src='+this.apiService.stagOneflowUrl+'/quoteStatus?fileId='+ localStorage.getItem('fileId')+'.'+this.commonService.commonMainObj.fileUploadedType;
                  this.emailConfirmAlert('',redirectUrl);
                  this.commonService.commonMainObj.tryToRegister = false;
                }else{
                  this.commonService.commonMainObj.tryToRegister = true;
                  var redirectUrl = this.apiService.portalUrl + 'customer-portal/signup/?src='+this.apiService.stagOneflowUrl+'/quoteStatus?fileId='+ localStorage.getItem('fileId')+'.'+this.commonService.commonMainObj.fileUploadedType+'&wqID='+this.commonService.commonMainObj.wqId+'&email='+this.commonService.commonMainObj.email
                  this.emailConfirmAlert('',redirectUrl);
                }
              }, error =>{
                console.log('Bom file saving Error2', error);
              })
            }
          }, error =>{
            console.log('Bom file saving Error2', error);
          })   
        }else{
          this.commonService.sessionPortalLoad();
          if(this.commonService.commonMainObj.userSessionMemberId){
            this.commonService.loadingShow();
            setTimeout(()=>{
              this.apiService.checkUserSessionApi().subscribe((data: any)=>{
                this.commonService.loadingHide();
                if(data.status == 1){
                  this.router.navigateByUrl('/quoteStatus');
                }
              },error =>{
                console.log('Error in checking user session', error);
              })
            },2000);
          }
        }
      }
    }
  }

  emailConfirmAlert(text:any,redirectUrl:any){
    if(text){
      Swal.fire({
        title: 'Info',
        text:text,
        showCancelButton: false,
        confirmButtonText: 'Ok',
        allowEscapeKey : false,
        backdrop:false
      }).then((result) => {
        if (result['isConfirmed']){
          window.open(redirectUrl,"_self");
        }else{
          localStorage.setItem('commonDataObj','');
          localStorage.setItem('apiSerDataObj','');
          localStorage.setItem('apDtId','');
        }
      })
    }else{
      window.open(redirectUrl,"_self");
    }
  }

  
  checkedLineItem(selectType:any){
    this.commonService.commonMainObj.listOfMpnsSelected = [];
    setTimeout(()=>{
      if(selectType == ''){
        for(var i in this.commonService.commonMainObj.allAvailableComponets){
          if(this.commonService.commonMainObj.allAvailableComponets[i].checkedModel && this.commonService.commonMainObj.allAvailableComponets[i].checkedModel == true){
            this.commonService.commonMainObj.listOfMpnsSelected.push(this.commonService.commonMainObj.allAvailableComponets[i].mpn)
          }
        }
      }else{
        if(this.headerCheck){
          for(var i in this.commonService.commonMainObj.allAvailableComponets){
            this.commonService.commonMainObj.allAvailableComponets[i].checkedModel = true;
            this.commonService.commonMainObj.listOfMpnsSelected.push(this.commonService.commonMainObj.allAvailableComponets[i].mpn)
          }
        }else{
          for(var i in this.commonService.commonMainObj.allAvailableComponets){
            this.commonService.commonMainObj.allAvailableComponets[i].checkedModel = false;
          }
        }
      }
    },500);
  }
}
